import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class ResponsibilitiesPresenter extends EntityPresenter {
  static urn = 'responsibilities'
  static key = 'responsibility'

  static navOptions(key = 'responsibilities') {
    const routes = {
      responsibilities: {
        icon: 'visibility',
        pageRoutes: ['responsibility'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(ResponsibilitiesPresenter)
